<div class="menu-search">
    <i class="pi pi-search menu-search-icon"></i>
    <input
        #navSearch
        type="text"
        class="menu-search-input"
        autocomplete="off"
        spellcheck="false"
        [attr.aria-label]="'MENU_SEARCH_PLACEHOLDER' | language:'MENU_SEARCH_PLACEHOLDER':languageService.currentLanguage"
        [placeholder]="'MENU_SEARCH_PLACEHOLDER' | language:'MENU_SEARCH_PLACEHOLDER':languageService.currentLanguage"
        [(ngModel)]="navQuery"
        (ngModelChange)="onNavQuery()"
        (keydown)="onNavKeydown($event)" />
    <button *ngIf="navQuery" type="button" class="menu-search-clear" (click)="clearNavQuery(); navSearch.focus()" aria-label="Clear">
        <i class="pi pi-times"></i>
    </button>
    <kbd *ngIf="!navQuery" class="menu-search-hint">/</kbd>
</div>

<ul *ngIf="navQuery.trim()" class="menu-search-results" role="listbox">
    <li *ngFor="let hit of navResults; let i = index" role="option" [attr.aria-selected]="i === navActive">
        <a [routerLink]="hit.routerLink" [class.is-active]="i === navActive" (mouseenter)="navActive = i" (click)="openNavResult(hit); $event.preventDefault()">
            <span class="menu-search-result-label">{{ hit.label }}</span>
            <span *ngIf="hit.trail" class="menu-search-result-trail">{{ hit.trail }}</span>
        </a>
    </li>
    <li *ngIf="!navResults.length" class="menu-search-empty">
        {{ 'MENU_SEARCH_EMPTY' | language:'MENU_SEARCH_EMPTY':languageService.currentLanguage }}
    </li>
</ul>

<!-- Hidden rather than removed while searching, so open groups stay open. -->
<ul class="layout-menu" [hidden]="!!navQuery.trim()">
    <ng-container *ngFor="let item of model; let i = index;">
        <li app-menuitem *ngIf="!item.separator && item.items.length > 0" [item]="item" [index]="i" [root]="true"></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
